import React from 'react';
import {Link} from "react-router-dom";

const ContactBox = () => {
  return (
    <>
      <section className='contact-promo ptb-120'>
        <div className='container'>
          <div className='row justify-content-center'>
            <div className='col-lg-4 col-md-6 mt-4 mt-lg-0'>
              <div className='contact-us-promo p-5 bg-white rounded-custom custom-shadow text-center d-flex flex-column h-100'>
                <span className='fad fa-comment-alt-lines fa-3x text-primary'></span>
                <div className='contact-promo-info mb-4'>
                  <h5>Contact Sales</h5>
                  <p>
                    I'm looking for business payment solutions.
                  </p>
                </div>
                <Link
                  to='/contact-sales'
                  className='btn btn-primary mt-auto'
                >
                  Contact Sales
                </Link>
              </div>
            </div>
            <div className='col-lg-4 col-md-6 mt-4 mt-lg-0'>
              <div className='contact-us-promo p-5 bg-white rounded-custom custom-shadow text-center d-flex flex-column h-100'>
                <span className='fad fa-comment-alt-lines fa-3x text-primary'></span>
                <div className='contact-promo-info mb-4'>
                  <h5>Write to us</h5>
                  <p>
                    I want to partner with Sunlex.
                  </p>
                </div>
                <Link
                    to='/contact-partner'
                    className='btn btn-primary mt-auto'
                >
                  Become a Partner
                </Link>
              </div>
            </div>
            <div className='col-lg-4 col-md-6 mt-4 mt-lg-0'>
              <div className='contact-us-promo p-5 bg-white rounded-custom custom-shadow text-center d-flex flex-column h-100'>
                <span className='fad fa-envelope fa-3x text-primary'></span>
                <div className='contact-promo-info mb-4'>
                  <h5>Open a ticket</h5>
                  <p>
                    Need help? Submit a ticket to our support team to get assistance.
                  </p>
                </div>
                <Link
                    to='/contact-external-system'
                    className='btn btn-primary mt-auto'
                >
                  Create a ticket
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactBox;
